import { AvatarInput } from '@vueling-ng/vy-ds/src/lib/components/globals/avatar';
import { ListItem } from '@vueling-ng/vy-ds/src/lib/components/globals/list';
import { MenuHorizontalItem } from '@vueling-ng/vy-ds/src/lib/components/globals/menu-horizontal';
import { TableConfig } from '@vueling-ng/vy-ds/src/lib/components/globals/table';
import { BookingsResponse } from './bookings.interface';

export interface BookingListViewModel {
  userName: string;
  linksMenu: ListItem[];
  bookingsTableData: TableConfig | undefined;
  paginationInfo: PaginationInfo;
  totalBookingsFound: number | undefined;
  horizontalMenuItems: MenuHorizontalItem[];
  avatar: AvatarInput;
}

export interface PaginationInfo {
  currentPage: number | undefined;
  totalPages: number | undefined;
}

export const EmptyBookingListViewModel: BookingListViewModel = {
  userName: '',
  linksMenu: [],
  bookingsTableData: undefined,
  paginationInfo: {
    currentPage: undefined,
    totalPages: undefined
  },
  totalBookingsFound: undefined,
  horizontalMenuItems: [],
  avatar: {
    title: {
      firstLetter: '',
      secondLetter: ''
    }
  }
};

export const EmptyBooking: BookingsResponse = {
  totalPages: 0,
  pageSize: 0,
  page: 0,
  bookings: [],
  totalRequest: 0
};
